
export default "/assets/archive-box-mini.fc4093e3.svg"